const getUnitId = (state, props) => {
  return props.unitId ?? props.routeParams?.id ?? props.params?.id;
};

export default getUnitId;
